import React, { useState } from 'react';
import { ReactComponent as ViticulturaIcon } from '../../assets/icons/ViticulturaIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { invalidarCacheColecciones } from "../../services/dataCache";
import FechaDateInput from '../FechaDateInput';
const estadoInicial = {
pertenencia: '',
viticultura: {
provenienza: '',
nombre_finca: '',
altura_snm: '',
tipo_suelo: '',
dias_sol: '',
temperatura_media_anual: '',
precipitacion_media_anual: '',
humedad_media_anual: '',
tipo_riego: '',
variedad_uva: '',
fecha_primera_poda: '',
fecha_segunda_poda: '',
fecha_cosecha: '',
nivel_acido: '',
nivel_azucar: '',
nivel_ph: '',
quintales: '',
precioUnidad: null,
profesional_responsable: '',
}
};
const variedadesDeUva = [
'Albariño', 'Ancellotta', 'Bonarda', 'Cabernet Franc', 'Cabernet Sauvignon',
'Carmenère', 'Cereza', 'Chardonnay', 'Chenin Blanc', 'Criolla Grande',
'Garnacha', 'Malbec', 'Mencía', 'Merlot', 'Moscatel de Alejandría',
'Nebbiolo', 'Palomino', 'Pedro Giménez', 'Petit Verdot', 'Pinot Gris',
'Pinot Noir', 'Quebranta', 'Riesling', 'Sangiovese', 'Sauvignon Blanc',
'Semillón', 'Syrah', 'Tannat', 'Tempranillo', 'Torrontés',
'Touriga Nacional', 'Verdejo', 'Viognier', 'Zinfandel'
];
const tiposDeSuelo = [
'Arcillo arenoso',
'Arcillo limoso',
'Arcilloso',
'Arenoso',
'Calcáreo',
'Franco arenoso',
'Franco arcilloso',
'Franco calcáreo',
'Franco limoso',
'Limoso'
];
const tiposDeRiego = [
'Aspersión',
'Goteo',
'Manto',
'Surco'
];
const ViticulturaForm = () => {
const navigate = useNavigate();
const [formData, setFormData] = useState(estadoInicial);
const [message, setMessage] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [progress, setProgress] = useState(0);
const handlePertenenciaChange = (e) => {
const nuevaPertenencia = e.target.value;
const viticulturaLimpia = {
...estadoInicial.viticultura,
...formData.viticultura,
provenienza: nuevaPertenencia === 'propia' ? '' : '',
nombre_finca: nuevaPertenencia === 'tercero' ? '' : '',
};
setFormData(prev => ({
...prev,
pertenencia: nuevaPertenencia,
viticultura: viticulturaLimpia
}));
};
const handleChange = (e) => {
const { name, value, type } = e.target;
if (Object.keys(estadoInicial.viticultura).includes(name)) {
setFormData(prev => ({
...prev,
viticultura: {
...prev.viticultura,
[name]: type === 'number' ? Number(value) : value,
}
}));
}
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setProgress(0);
  setMessage(null);

  const user = getAuth().currentUser;
  if (!user) {
    setMessage({ type: 'error', text: 'Debes iniciar sesión para crear un lote.' });
    setIsLoading(false);
    return;
  }

  try {
    const idToken = await user.getIdToken();
    const datosParaEnviar = {
      pertenencia: formData.pertenencia,
      viticultura: { ...formData.viticultura }
    };

    if (formData.pertenencia === 'propia') {
      delete datosParaEnviar.viticultura.nombre_finca;
    } else {
      delete datosParaEnviar.viticultura.provenienza;
    }

    // Simulamos progreso mientras dura la petición
    const interval = setInterval(() => {
      setProgress(prev => Math.min(prev + 5, 95));
    }, 100);

    const response = await fetch('https://backend-288175208699.europe-west1.run.app/api/viticultura', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(datosParaEnviar),
    });

    clearInterval(interval);
    setProgress(100);
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Ocurrió un error.');
    }

    // Mostramos mensaje de éxito
    setMessage({ type: 'success', text: data.mensaje });

    // ✅ Extraer el ID del mensaje y redirigir
    const match = data.mensaje.match(/ID[:\s]+(\S+)/); // captura cualquier secuencia no vacía después de "ID:" o "ID "
    invalidarCacheColecciones();
    if (match && match[1]) {
      const id = match[1];
      setTimeout(() => {
        navigate(`/trazabilidad/${id}`);
      }, 800);
    } else {
      setIsLoading(false);
      setProgress(0);
    }

  } catch (error) {
    console.error("Error al enviar el formulario:", error);
    setMessage({ type: 'error', text: error.message });
    setIsLoading(false);
    setProgress(0);
  }
};

const esFormularioValido = () => {
  const { pertenencia, viticultura } = formData;

  if (!pertenencia) return false;
  if (!viticultura.variedad_uva) return false;
  if (!viticultura.profesional_responsable) return false;
  if (!viticultura.quintales) return false;
  // Si pertenece a propia/tercero, chequear el campo correspondiente
  if (pertenencia === 'propia' && !viticultura.provenienza) return false;
  if (pertenencia === 'tercero' && !viticultura.nombre_finca) return false;

  return true;
};

const provenienzaOptions = [
  { value: 'cuartel', label: 'Cuartel' },
  { value: 'hectarea', label: 'Hectárea' },
  { value: 'hilera', label: 'Hilera' },
  { value: 'parcela', label: 'Parcela' }
];
return (
<div className="container">
<div className="formtitle-container">
<div className="formicon-container">
<ViticulturaIcon className="formicon" />
</div>
<h1 className="formtitle">Viticultura</h1>
</div>
<hr className="divider" />
<form onSubmit={handleSubmit} className="form">
<div className="columns-container">
{}
<div className="column">
<div className="input-group">
<Listbox
value={formData.pertenencia}
onChange={(value) => handlePertenenciaChange({ target: { value } })}
>
  {({ open }) => (
    <>
      <ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
        formData.pertenencia ? 'selected' : 'placeholder'}`}>
        {formData.pertenencia ? formData.pertenencia.charAt(0).toUpperCase() + formData.pertenencia.slice(1) : "Tipo de propiedad"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {["propia", "tercero"].map((option) => (
          <ListboxOption
            key={option}
            value={option}
            className="custom-listbox-option"
          >
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
{formData.pertenencia === 'propia' && (
<div className="input-group">
<Listbox
  value={formData.viticultura.provenienza}
  onChange={(value) => handleChange({ target: { name: 'provenienza', value } })}
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? 'open' : ''} ${
          formData.viticultura.provenienza ? 'selected' : 'placeholder'
        }`}
      >
        {
          provenienzaOptions.find(opt => opt.value === formData.viticultura.provenienza)?.label 
          || "Área de cosecha"
        }
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {provenienzaOptions.map((option) => (
          <ListboxOption
            key={option.value}
            value={option.value}
            className="custom-listbox-option"
          >
            {option.label}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
)}
{formData.pertenencia === 'tercero' && (
<>
<div className="input-group">
    <input type="text" name="nombre_finca" value={formData.viticultura.nombre_finca} onChange={handleChange} className="input" placeholder="Nombre de la finca"  />
</div>
</>
)}
<div className="input-group">
<Listbox
value={formData.viticultura.tipo_suelo}
onChange={(value) => handleChange({ target: { name: 'tipo_suelo', value } })}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.viticultura.tipo_suelo ? 'selected' : 'placeholder'
}`}>
{formData.viticultura.tipo_suelo || "Tipo de suelo"}
<span className="custom-arrow-container">
    <span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeSuelo.map((suelo) => (
    <ListboxOption
    key={suelo}
    value={suelo}
    className="custom-listbox-option"
    >
    {suelo}
    </ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
<Listbox
value={formData.viticultura.tipo_riego}
onChange={(value) => handleChange({ target: { name: 'tipo_riego', value } })}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.viticultura.tipo_riego ? 'selected' : 'placeholder'
}`}>
{formData.viticultura.tipo_riego || "Tipo de riego"}
<span className="custom-arrow-container">
    <span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDeRiego.map((riego) => (
    <ListboxOption
    key={riego}
    value={riego}
    className="custom-listbox-option"
    >
    {riego}
    </ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group number">
<input type="number" name="altura_snm" value={formData.viticultura.altura_snm} className="input" onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,altura_snm: value === '' ? null : parseFloat(value)}});}} placeholder="Altura sobre el nivel del mar" />
  <span className="unit">metros</span>
</div>
</div>

<div className="column">
<div className="input-group">
<Listbox
value={formData.viticultura.variedad_uva}
onChange={(value) => handleChange({ target: { name: 'variedad_uva', value } })}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${
formData.viticultura.variedad_uva ? 'selected' : 'placeholder'
}`}>
{formData.viticultura.variedad_uva || "Cepa"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{variedadesDeUva.map((uva) => (
<ListboxOption
key={uva}
value={uva}
className="custom-listbox-option"
>
{uva}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
    <label className='date-label'>Fecha de poda de invierno</label>
<FechaDateInput name="fecha_primera_poda" value={formData.viticultura.fecha_primera_poda} onChange={(iso) => setFormData(prev => ({ ...prev, viticultura: { ...prev.viticultura, fecha_primera_poda: iso } }))} className="input" placeholder="Fecha Primera Poda"  />
</div>
<div className="input-group">
    <label className='date-label'>Fecha de poda de verano</label>
<FechaDateInput name="fecha_segunda_poda" value={formData.viticultura.fecha_segunda_poda} onChange={(iso) => setFormData(prev => ({ ...prev, viticultura: { ...prev.viticultura, fecha_segunda_poda: iso } }))} className="input" placeholder="Fecha Segunda Poda"  />
</div>
<div className="input-group">
    <label className='date-label'>Fecha de cosecha</label>
<FechaDateInput name="fecha_cosecha" value={formData.viticultura.fecha_cosecha} onChange={(iso) => setFormData(prev => ({ ...prev, viticultura: { ...prev.viticultura, fecha_cosecha: iso } }))} className="input" placeholder="Fecha de Cosecha" />
</div>
<div className="input-group number">
  <input
    type="number"
    name="nivel_acido"
    value={formData.viticultura.nivel_acido ?? ''}
    onChange={(e) => {
      const value = e.target.value;
      setFormData({
        ...formData,
        viticultura: {
          ...formData.viticultura,
          nivel_acido: value === '' ? null : parseFloat(value)
        }
      });
    }}
    className="input"
    step="0.1"
    placeholder="Nivel de acidéz"
  />
  <span className="unit">g/L</span>
</div>
<div className="input-group number">
<input 
type="number" 
name="nivel_azucar" 
value={formData.viticultura.nivel_azucar} 
onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,nivel_azucar: value === '' ? null : parseFloat(value)}});}}
className="input" 
step="0.1"
placeholder="Nivel de azúcar" 
 
/>  <span className="unit">° Brix</span>
</div>
<div className="input-group number">
<input 
type="number" 
name="nivel_ph" 
value={formData.viticultura.nivel_ph} 
onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,nivel_ph: value === '' ? null : parseFloat(value)}});}}
className="input" 
step="0.01"
placeholder="Nivel de pH" 
 
/><span className="unit">pH</span>
</div>
<div className="input-group number">
<input type="number" name="quintales" value={formData.viticultura.quintales} onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,quintales: value === '' ? null : parseFloat(value)}});}} className="input" placeholder="Quintales cosechados"  />
<span className="unit">q</span>
</div>
</div>
{}
<div className="column-last" >

<div className="input-group number">
<input type="number" name="dias_sol" value={formData.viticultura.dias_sol} onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,dias_sol: value === '' ? null : parseFloat(value)}});}} className="input" placeholder="Cantidad de días de sol"  />
<span className="unit">d</span>
</div>
<div className="input-group number">
<input type="number" name="precipitacion_media_anual" value={formData.viticultura.precipitacion_media_anual} onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,precipitacion_media_anual: value === '' ? null : parseFloat(value)}});}} className="input" placeholder="Precipitación medial anual"  />
<span className="unit">mm</span>
</div>
<div className="input-group number">
<input type="number" name="temperatura_media_anual" value={formData.viticultura.temperatura_media_anual} onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,temperatura_media_anual: value === '' ? null : parseFloat(value)}});}} className="input" step="0.1" placeholder="Temperatura media anual"  />
<span className="unit">°C</span>
</div>
<div className="input-group number">
<input type="number" name="humedad_media_anual" value={formData.viticultura.humedad_media_anual} onChange={(e) => {const value = e.target.value; setFormData({...formData,viticultura: {...formData.viticultura,humedad_media_anual: value === '' ? null : parseFloat(value)}});}} className="input" placeholder="Humedad media anual"  />
  <span className="unit">%</span></div>

<div className="button-container" style={{width: '370px'}}>
  <div className="input-group number">
  <input
    type="number"
    name="precioUnidad"
    value={formData.viticultura.precioUnidad ?? ''}
    onChange={(e) => {
      const value = e.target.value;
      setFormData({
        ...formData,
        viticultura: {
          ...formData.viticultura,
          precioUnidad: value === '' ? null : parseFloat(value)
        }
      });
    }}
    className="input"
    step="0.01"
    placeholder="Precio por quintal"
    style={{marginBottom: '0px'}}
  />
  <span className="unit">$</span>
</div>
<div className="input-group">

      <input 
    type="text" 
    name="profesional_responsable" 
    value={formData.viticultura.profesional_responsable} 
    onChange={handleChange} 
    className="input" 
    placeholder="Profesional responsable" 
    style={{marginBottom: '0px', marginTop:'auto'}}
    required 
  /></div>
 <hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
    type="submit"
    className={`button ${message?.type === 'success' ? 'success' : ''}`}
    disabled={isLoading || !esFormularioValido()}
>
    <span className="button-text">
        {message?.type === 'success' ? 'Guardado' : isLoading ? 'Creando...' : 'Crear lote'}
    </span>
    {isLoading && (
        <span
            className="progress-bar"
            style={{ width: `${progress}%` }}
        ></span>
    )}
</button>
</div>
</div>

</div>

{message && (
<div className={`message ${message.type}`}>
{message.text}
</div>
)}
</form>
</div>
);
};
export default ViticulturaForm;